var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSpotifyHeroBurst01 = function SvgSpotifyHeroBurst01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2574 2213",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 0h2574v2213H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    mask: "url(#b)",
    d: "M2573.884 0l-325.66 2713.14-62.825 507.477H-900L917.328 760.791 353.254 2379.225l725.943-844.763-153.09 663.527z"
  }))));
};
export default SvgSpotifyHeroBurst01;